import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { Tab, TabIconPosition } from "@jsq/ds/core";
import { IconVariant, IconType } from "@jsq/ds/icons";
import * as styles from "./styles_vanilla.css";

export interface HomeTabProps {
  tabKey: string;
  tabLabel: string;
  route?: string;
  icon?: IconType;
  iconVariant?: IconVariant;
  iconPosition?: TabIconPosition;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const HomeTab: React.FC<HomeTabProps> = (props: HomeTabProps) => {
  const { tabKey, tabLabel, route, icon, iconVariant, iconPosition, className, onClick } =
    props;
  const { pathname } = useLocation();

  const handleClick = onClick
    ? (e: React.MouseEvent) => {
        e.preventDefault();
        onClick(e);
      }
    : undefined;

  const isActive = route ? pathname.includes(route) : false;

  return (
    <Tab
      className={clsx(styles.navTabStyle, icon && styles.tabLabelWithIcon, className)}
      text={tabLabel}
      active={isActive}
      to={route}
      data-cy={`${tabKey}-tab`}
      icon={icon}
      iconVariant={iconVariant}
      iconPosition={iconPosition}
      onClick={handleClick}
    />
  );
};
